// zh.js
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'   //引入element语言包
import UserAnswer from './UserAnswer'
import PublishProject from './PublishProject'
import SetUp from './SetUp'
import Appearance from './Appearance'
import DataRecycling from './DataRecycling'
import Preview from './Preview'
import QuesLibrary from './QuestionnaireLibrary'
import Personal from './Personal'
import Mywallet from './Mywallet'
import Quota from './Quota'

const lang = {
  main:{
    // 问卷列表以及公共部分
    message: '消息',
    display: '展示',
    ok: '确定',
    cancel: '取消',
    ok2: '确 定',
    cancel2: '取 消',
    Restore: '恢复',
    delete: '删除',
    save: '保存',
    save1: '保 存',
    pleaseEnterYourPhoneNumber: '请输入手机号',
    enterOneUserName: '请输入用户名',
    pleaseInputPassword: '请输入密码',
    PleaseEnterValidPhoneNumber: '请输入有效的手机号码',
    SMSSentSuccessfully: '短信发送成功!',
    MyQuestionnaire: '我的问卷',
    MyExam: '我的考试',
    QuesLibrary: '问卷库',
    ExamQuestionBank: '考试题库',
    UserManagement: '用户管理',
    userInformation: '用户信息',
    myDownloads: '我的下载',
    myWallet: '我的钱包',
    CustomerServiceCenter: '客服中心',
    liaison: '联系人',
    advancedSetting: '高级设置',
    QuestionnaireStatus: '问卷状态',
    CreationTime: '创建时间',
    DeleteTime: '删除时间',
    PleaseEnterContent: '请输入内容',
    recycleBin: '回收站',
    title: '标题',
    type: '类型',
    state: '状态',
    Editing: '编辑中',
    ConscriptionConcentration: '征集中',
    Ended: '已结束',
    inReview: '审核中',
    collectData: '收集数据',
    time: '时间',
    operate: '操作',
    edit: '编辑',
    Preview: '预览',
    Release: '发布',
    data: '数据',
    PublishProject: '发布项目',
    PreviewProject: '预览项目',
    CopyProject: '复制项目',
    wipeData: '清空数据',
    deleteItem: '删除项目',
    questionnaire: '问卷',
    ThereIsCurrentlyNoDataAvailable: '暂无数据',
    PleaseEnterYourLoginPassword: '请输入登录密码',
    whole: '全部',
    Completed: '已完成',
    PleaseSelectAPieceOfData: '请选择一条数据',
    DataPreparationIsUnderway: '数据准备中，预计5分钟后完成。前往',
    CanViewProgress: '可查看进度',
    PleaseEnterTheAccountPassword: '请输入账户密码。',
    DoYouWantToClearTheCurrentData: '是否要清空当前数据？',
    tip: '提示',
    EmptyCanceled: '已取消清空',
    CanBeRestored: '当前项目删除后将移入回收站,可进行恢复。',
    ImportWasSuccessful: '导入成功',
    ImportFailed: '导入失败，请重新导入',
    SuccessfullyCopiedProject: '复制项目成功！',
    ImportQuestionnaire: '导入问卷',
    DownloadTemplate: '下载模板',
    DownloadToLocal: '点击下载模板，将问卷模板下载到本地',
    AutomaticallyGenerateQuestionnaires: '点击导入问卷，自动生成问卷',
    ModificationPrompt: '修改提示',
    QuestionnaireCollected: '该问卷已收集',
    PausePublishing: '份数据,修改问卷可能会影响已收集的数据，问卷在修改时，会暂停发布，您需要在修改完之后重新发布才可继续收集数据',
    PausePublishingPrompt: '暂停发布提示',
    PausePublishingPromptText: '您修改问卷时，问卷会暂停发布，您需要在修改完成后重新发布问卷才可继续进行数据收集，原问卷链接不会改变。',
    CreateABlankQuestionnaire: '创建空白问卷',
    ReferenceTemplate: '引用模板',
    EditItem: '编辑项目',
    Dataecycling: '数据回收',
    ExitListPage: '当前问卷编号已经丢失，可能是清除浏览器缓存原因。系统将退出到列表页面。',
    PleaseEnterKeywordSearch: '请输入关键词搜索',
    SearchFor: '搜索',
    // 问卷设计
    export: '导出',
    import: '导入',
    useTest: '测试使用',
    OptionGrouping: '选项分组',
    OptionsToBeGrouped: '待分组选项',
    GroupedlTips: '提示：请选中左侧选项并加入右侧分组',
    GroupManagement: '分组管理',
    AddGroup: '添加分组',
    join: '加入',
    GroupName: '分组名称',
    moveUp: '上移',
    MoveDown: '下移',
    QuestionType: '题型',
    Appearance: '外观',
    questionBank: '题库',
    outline: '大纲',
    copy: '复制',
    paste: '粘贴',
    clickQuestionTypeAddQuestion: '点击题型可添加题目',
    CompleteEditing: '完成编辑',
    QuestionSetting: '题目设置',
    pageNumber: '页码',
    WholeQuestionSetting: '整题设置',
    QuestionMustAnswered: '此题必答',
    ProblemCode: '问题编码',
    ProblemCodeHasBeenUsedAndCannotBeReused: '问题编码已被使用，不能重复使用',
    uniqueIdentification: '唯一标识，例',
    MaximumNumberOfUploadedFiles: '最大上传文件数量',
    PleaseSelect: '请选择',
    DisplayStyle: '显示样式',
    lowestScore: '最低分',
    MinimumScoreMustNotBeGreaterThanOrEqualToTheMaximumScore: '最低分不得大于或等于最高分',
    highestScore: '最高分',
    highestScoreMustNotBeLessThanOrEqualToTheLowestScore: '最高分不得小于或等于最低分',
    LogicalSettings: '逻辑设置',
    AddLogicalPrompts: '加入逻辑设置后，答题者可根据回答，从而跳转或显示不同题目',
    setUp: '设置',
    MutualExclusionInfluence: '互斥&影响',
    MutualExclusion: '互斥',
    Effect: '影响',
    AdvancedScripting: '高级脚本',
    DisplayLineOfIncidenceMatrixQuestion: '关联矩阵题显示行',
    SumOfRestrictedSpecificGravity: '限制比重总和',
    TotalSpecificGravity: '比重总和',
    PromptText: '提示文字',
    LeftPromptText: '左边提示文字',
    IntermediatePromptText: '中间提示文字',
    PromptTextOnTheRight: '右边提示文字',
    ManualPositionCorrectionNotAllowed: '不允许手动修正位置',
    InputBoxSize: '输入框大小',
    small: '小',
    middle: '中',
    big: '大',
    QuestionTypeSwitching: '题型切换',
    SingleRow: '单行',
    multipleRows: '多行',
    Radio: '单选',
    MultipleChoice: '多选',
    RandomArrangementOfRows: '「行」随机排列',
    RandomArrangementOfColumns: '「列」随机排列',
    MatrixRowColumnExchange: '矩阵行列交换',
    FillingBoxOnTheMobilePhoneCanSlideToAppear: '手机端填写框可滑动出现',
    PagingSettings: '分页设置',
    applyToAll: '应用于全部',
    MinimumTime: '最短时间',
    MinimumTimeToStayOnThisPage: '本页需停留最短时间',
    EnterSeconds: '输入秒',
    second: '秒',
    MaximumTime: '最长时间',
    PageNeedsToStayForTheLongestTime: '本页需停留最长时间',
    MoreSettings: '更多设置',
    PreviousButtonText: '上一页按钮文字',
    NextPageButtonText: '下一页按钮文字',
    ShowPreviousPagButton: '显示上一页按钮',
    OptionalRange: '可选范围',
    theLeast: '最少',
    noLimit: '不限',
    term: '项',
    atMost: '最多',
    OptionSettings: '选项设置',
    subset:'分组',
    OptionGroupingPrompt: '当选项多时，通过设置选项分组，可帮助答题者更高效答题。',
    DetailLevel: '详细程度',
    RandomlyArrangeOptions: '选项随机排列',
    FixTheLastOption: '固定最后一个选项',
    LimitSpecificGravityMinimumMaximumValue: '限制比重最小/最大值',
    minimumValue: '最小值',
    minimumMustNotBeGreaterThanOrQqualToTheMaximumValue: '最小值不得大于或等于最大值',
    MaximumValue: '最大值',
    OnlySelect: '仅选出',
    place: '位',
    OptionLayout: '选项布局',
    arrange: '列',
    OptionAssociation: '选项关联',
    LabelSettings: '标签设置',
    tagName: '标签名称',
    PleaseEnterALabelName: '请输入标签名称',
    SettingsFor: '的设置',
    AddAFillInBoxAfterTheOption: '在选项后边增加填空框',
    ContentRestrictions: '内容限制',
    WordLimit: '字数限制',
    WithinWords: '字内',
    formatLimits: '格式限制',
    FillInAtLeast: '最少填写',
    FillInAtMost: '最多填写',
    DefaultText: '默认文本',
    ThisBlankCanBeLeftBlank: '该空可不填',
    questionBank: '题库',
    problem: '问题',
    increase: '添加',
    FillInTheBlankAttribute: '填空属性',
    FillInTheBlankNumber: '填空序号',
    WordRange: '字数范围',
    ThisBlankIsMandatory: '此空必填',
    HowManyWordsCanIFillInAatMost: '最多填写多少字',
    word: '字',
    BatchAddOptions: '批量添加选项',
    EditTitle: '编辑标题',
    SetTheQuestion: '将题目',
    PleaseSelectAnOption: '请选择选项',
    SelectedItemsAsOptionsForThisQuestion: '选中项作为本题选项',
    FinishedEditing: '已完成编辑，是否立即发布？',
    continueEditing: '继续编辑',
    PublishNow: '立即发布',
    percentage:'百分比',
    Selected: '选中',
    notSelected: '未选中',
    show: '显示',
    NoShow: '不显示',
    numeral: '数字',
    letter: '字母',
    Chinese: '中文',
    Email: 'Email',
    cellPhoneNumber: '手机号',
    Url: '网址',
    ID: '身份证',
    Item1: '1项',
    Item2: '2项',
    DetailedToDetailedAddress: '详细到“详细地址”',
    DetailedToCity: '详细到“区县”',
    DetailedTopProvince: '详细到“省份”',
    maximumValueMustNotBeLessThanOrEqualToTheMinimumValue: '最大值不得小于或等于最小值',
    ReplicatingSuccess: '复制成功',
    PleaseSelectTheTestQuestionFirst: '请先选择试题',
    ThereAreCurrentlyNoTestQuestionsToPaste: '暂无可粘贴的试题',
    CannotBeEmpty: '不能空',
    PleaseSelectAFile: '请选择文件',
    fileReadFailure: '文件读取失败，请检查。',
    maximumValueMustNotExceedTheTotalSpecificGravity: '最大值不得大于比重总和',
    ImageUploadQuestionDidNotUploadImages: '图片上传题未上传图片',
    EnterAtLeastOneOption: '最少输入一个选项！',
    option: '选项',
    matrix: '矩阵',
    SuccessfullyAppliedToAll: '应用于全部成功！',
    NoOptionsAvailable: '没有任何选项,请设置!',
    AddedSuccessfully: '添加成功！',
    questionHasAlreadyParticipatedInLogicalSetting: '该题已参与逻辑设置，不能删除！',
    questionOptionIsAlreadyAssociatedWithAnotherQuestion: '该题目选项已关联其他题目，不能删除！',
    firstPageIsTheDefaultPage: '第一页为默认页，不能删除！',
    operationWillPermanentlyDeleteTheData: '此操作将永久删除该数据, 是否继续?',
    CancelledDeletion: '已取消删除',
    other: '其他',
    PleaseRemoveTheOptionFromTheGroup: '请将选项从分组中移除',
    SuccessfullyDeletedThePption: '成功删除该选项',
    member: '成员',
    MatrixRow: '矩阵行',
    MatrixColumn: '矩阵列',
    minimumOptionsCannotExceedTheMaximumOptions: '最少选项不可多于最多选项',
    QuestionnaireType: '问卷类型',
    AssociatedFrom: '关联自',
    de: '的',
    Options: '个选项',
    text: '文本',
    CancelFavorite: '取消收藏',
    CancelFailed: '取消失败',
    CollectionSuccessful: '收藏成功',
    SingleLineInputBox: '单行输入框',
    MultilineInputBox: '多行输入框',
    fillInTheBlanks: '填空题',
    CollectToQuestionBank: '收藏到题库',
    ThereIsCurrentlyNoQuestionBankAvailable: '暂无题库',
    CannotBeEmpty: '不能为空',
    create: '创建',
    CreateANewQuestionBank: '新建题库',
    Unclassified: '未分类',
    AddOptions: '添加选项',
    BatchAdd: '批量添加',
    AddOther: '添加【其他】',
    NewOptions: '新增选项',
    multipleChoice: '多项选择',
    UploadFailed: '上传失败！',
    EachRowRepresentsOne: '每行代表一个',
    MultipleCanBeAdded: '可以添加多个',
    MultipleOptionsCanAdded: '每行代表一个选项，可以添加多个选项',
    determine: '判断',
    MultipleBlankFilling: '多项填空',
    fillInTheBlanks: '填空',
    AddAndFillInTheBlank: '新增填空',
    dropDown: '下拉',
    PictureSelection: '图片选择',
    Upload1SheetAtATime: '当次上传1张',
    UpTo10CopiesCanBeUploaded: '最多可上传10张',
    modify: '修改',
    ValidationFailed: '验证失败',
    CurrentLimitSelection: '当前限制选择 3 张图片，如需更换，请删除上一张图片在重新选择！',
    StarRating: '星级评分',
    score: '评分',
    ScaleQuestions: '量表题',
    DateSelection: '日期选择',
    year: '年',
    month: '月',
    day: '日',
    SelectDate: '选择日期',
    SortQuestion: '排序题',
    addressLocation: '地址位置',
    ClickToObtainGeographicalLocation: '点击获取地理位置',
    CitySelection: '城市选择',
    PleaseSelectAProvince: '请选择省份',
    PleaseSelectACity: '请选择城市',
    PleaseSelectADistrictOrCounty: '请选择区/县',
    PleaseFillInTheDetailedAddress: '请填写详细地址',
    MatrixRadioSelection: '矩阵单选',
    addRows: '添加行',
    AddColumn: '添加列',
    BatchAddRows: '批量添加行',
    BatchAddColumns: '批量添加列',
    InsertSpaceFiller: '插入填空符',
    KeepAtLeastOneOption: '至少保留一条选项',
    KeepAtLeastOneSubTopic: '至少保留一个子题目！',
    MatrixMultipleSelection: '矩阵多选',
    MatrixStarRating: '矩阵星级评分',
    Scoring: '打分',
    MatrixFillingInTheBlank: '矩阵填空',
    PageNumber: '页码',
    UploadFiles: '上传文件',
    ChooseToUploadFilesWithin10M: '选择上传文件(10M以内)',
    Timing: '时间选择',
    SelectTime: '选择时间',
    FillInTheBlankHorizontally: '横向填空',
    TheLengthDeterminesTheWidthOfFillingInTheBlanks: '每个填空符为2个汉字宽度，可连续输入，其长短决定答题填空宽度，可用键盘删除键回退内容',
    Range: '范围',
    CascadeQuestions: '级联题',
    EditingOptions: '编辑选项',
    Query: '查询',
    SpecificGravityQuestion: '比重题',
    Proportion: '比重',
    SetColumnProperties: '设置列属性',
    SetRowProperties: '设置行属性',
    CurrentTopic: '当前题目',
    ColumnHeader: '列标题',
    RowHeader: '行标题',
    ValidateProperties: '验证属性',
    MinimumWordCount: '最小字数',
    MaximumWordCount: '最大字数',
    MultilineText: '多行文本',
    SingleLineText: '单行文本',
    Integer: '整数',
    FixedLine: '固话',
    DropdownOptions: '下拉选项',
    FileUpload: '文件上传',
    English: '英文',
    TraditionalChinese: '繁体中文',
    FirstLevelOptions: '一级选项',
    SecondaryOptions: '二级选项',
    ThirdLevelOptions: '三级选项',
    FourthLevelOption: '四级选项',
    ThisOptionCannotBeDeleted: '该选项不可删除',
    ImportOptions: '导入选项',
    ClickToUpload: '点击文件到此区域进行上传',
    Download: '下载',
    BatchAddQuestionTypes: '批量添加题型',
    ImportQuestion: '导入题目',
    PleaseSearchForTagsOrNamesOrQuestioBanks: '请搜索标签/名称/题库',
    SelfBuiltQuestionBank: '自建题库',
    Refresh: '刷新',
    Quote: '引用',
    ThereIsCurrentlyNoContentAvailable: '暂无内容',
    SystemQuestionBank: '系统题库',
    QuestionBankName: '题库名称',
    TheQuestionBankNameCannotBeEmpty: '题库名称不能为空',
    Rename: '重命名',
    DeleteAllQuestionsWithinTheGroup: '删除分组内所有题目',
    DeleteConfirmation: '删除确认',
    ScaleSettings: '量表设置',
    ExtremeValueLabel: '极值标签',
    CustomContent: '自定义内容',
    ScaleSetting: '量级设置',
    Level: '级',
    StartingValue: '起始数值',
    PleaseEnterAValueWithinMax89: '请输入-9-89以内的数值',
    PleaseEnterAValueWithinMax100: '请输入-100-100以内的数值',
    PleaseEnterAValueWithinMax10: '请输入1-10以内的数值',
    Satisfaction: '满意度',
    Identity: '认同度',
    Willingness: '意愿度',
    Importance: '重要度',
    Conformance: '符合度',
    Perception: '感知度',
    Feasibility: '可行性',
    Custom: '自定义',
    VeryDissatisfied: '非常不满意',
    VerySatisfied: '非常满意',
    StronglyDisagree: '非常不赞同',
    StronglyAgree: '非常赞同',
    VeryReluctant: '非常不愿意',
    VeryWilling: '非常愿意',
    VeryUnimportant: '非常不重要',
    VeryImportant: '非常重要',
    VeryInconsistent: '非常不符合',
    VeryConsistent: '非常符合',
    Senseless: '毫无感觉',
    VeryStrong: '十分强烈',
    Impossible: '不可能',
    InAllLikelihood: '极有可能',
    ScoreSetting: '分值设置',
    ScoreConversionRatioOfThisQuestion: '该题分值转换比例',
    ClosedLoopOrNot: '是否闭环',
    FillingRestrictions: '填写限制',
    MinimumMustNotBeGreaterThanOrEqualToMaximum: '最少字数不得大于等于最大字数',
    MaximumMustNotBLessThanOrEqualToMinimum: '最多字数不得小于等于最少字数',
    JumpLogic: '跳转逻辑',
    JumpLogics: '条跳转逻辑',
    UnconditionalSkipQuestions: '无条件跳题',
    SkipQuestionsAccordingToConditions: '按条件跳题',
    AddLogic: '新增逻辑',
    AfterAnsweringThisQuestionJumpTo: '回答此题后跳转到',
    PleaseSelectAQuestion: '请选择题目',
    Provided: '如果',
    StartingScore: '起始分数',
    EndScoreScore: '结束分数',
    ThenJumpTo: '则跳转到',
    DisplayLogic: '显示逻辑',
    BarDisplayLogic: '条显示逻辑',
    DisplayThisQuestionIfTheFollowingConditionsAreMet: '满足以下条件显示该题',
    SetConditionsAndTestQuestionsToBeDisplayed: '设置条件以及需要显示的试题',
    Just: '且',
    Perhaps: '或',
    Arbitrarily: '任意',
    EqualTo: '等于',
    GreaterThan: '大于',
    LessThan: '小于',
    Betweenness: '介于',
    AnyOption: '任意选项',
    NormalEndIncludedInTheResult: '正常结束（计入结果）',
    EarlyTerminationDoesNotCountTowardsResults: '提前结束（不计入结果）',
    AddConditions: '添加条件',
    When: '当',
    ThisQuestion: '该题',
    PleaseSelectACondition: '请选择条件',
    ThenDisplay: '则显示',
    AddTestQuestions: '添加试题',
    AddDisplayLogic: '添加显示逻辑',
    NewlyAdded: '新增',
    Give: '与',
    MutualInfluence: '互相影响',
    Enter: '请输入',
    Help: '帮助',
    GiveAnExample: '举例',
    MeetTheFollowingRequirements: '符合以下',
    ShowThisIssueWhenConditionsAreMet: '条件时显示此问题',
    NormalCompletion: '正常完成',
    ShowWhen: '时显示',
    PleaseFillOInThisItem: '请填写本项内容',
    PleaseSelectTheFollowingImage: '请选择以下图片',
    PleaseSelectAnOption: '请选择一个选项',
    SelectMultipleOptions: '请选择以下选项 (多选)',
    SelectTheFollowingOptions: '请选择以下选项',
    SortTheFollowingOptions: '请给以下选项排序',
    RateTheFollowingItems: '请给以下各项打分',
    FillInTheFollowingInformation: '请填写以下内容',
    Headings: '段落标题',
    NextPage: '下一页',
    LastPage: '上一页',
    FullName: '姓名',
    Age: '年龄',
    Year: '岁',
    ContactInformation: '联系方式',
    PercentageOfEachItem: '请选择以下各项所占的百分比',
    EvaluateThisProject: '请您对此项目进行评价',
    FillInMemberInformation: '请填写你的团队成员信息',
    Correct: '正确',
    Error: '错误',
    SingleChoice: '单选题',
    MultipleChoiceQuestions: '多选题',
    TrueOrFalse: '判断题',
    ParagraphDescription: '段落说明',
    TextFilling: '文本填写',
    QuestionCitation: '问题引用',
    SearchForIssueLabelsOrIssueTitles: '请搜索问题标签/问题标题',
    BatchReference: '批量引用',
    ProblemLabel: '问题标签',
    QuestionTitle: '问题标题',
    AffiliatedQuestionBank: '所属题库',
    PersonalTemplate: '个人模板',
    SystemTemplate: '系统模板',
    TimeCited: '被引用次数',
    FilingNumber: '©2009-2026 北京东方艾学信息技术有限责任公司 京ICP备19053717号-1',
    Disable: '禁用'
  },
  ImportQuestion: {
    TextImport: '文本导入',
    TextEditing: '文本编辑',
    ExampleAndHelp: '示例&帮助',
    ClearText: '清空文本',
    PasteTheDocumentHere: '请将已准备好的文档按示例格式复制粘贴到这里',
    QuestionPreview: '题目预览',
    CreateProject: '创建项目',
    WelcomeMessage: '欢迎语',
    PreviewExample: '预览示例',
    Example1: '中国的火警报警电话是',
    Example2: '东方神采多选题支持哪些计分方式？',
    Example3: '腊月的最后一天为除日，所以腊月的最后一天晚上叫除夕。',
    Example4: '《史记》的作者是？',
    Example5: '请确认上述问题的答题，然后提交',
    ScoringMethod1: '全部答对才得分',
    ScoringMethod2: '答对几项得几分，答错不得分',
    ScoringMethod3: '每个选项都有相应分值',
    Yes: '是',
    No: '否',
    FormatDescription: '格式说明',
    FormatDescription1: '题目标题最好以数字开头；',
    FormatDescription2: '建议在题目后面添加题型标识，未标识的题目系统将自动识别；',
    FormatDescription3: '目前可识别的题型标识包括：【欢迎语】、【单选题】、【多选题】、【判断题】、【填空题】、【段落说明】；',
    FormatDescription4: '如果无法正确识别，请尝试在题目与题目之间加入空行；',
    FormatDescription5: '请勿在选项与选项之间空行。',
    FormatDescription6: '在【单选题】、【多选题】、【判断题】选项后增加“【文本填写】”字样，选项后会增加文本输入框。',
    FormatDescription7: '在【单选题】、【多选题】、【判断题】选项后，或者【填空题】题目后增加“---JumpToQ4”、“---NormalEnd”、“---EarlyTermination”字样，增加跳转逻辑。',
    FormatDescription8: '在题目后面添加“【ProblemLabel：标签1】”字样，添加问题标签。',
    FormatDescription9: '结束语：结束语分为',
    ClearPrompt: '确认清空文本吗？清空后，将无法恢复已输入文本',
    ErrorMessage: '错误信息',
    ProjectTitle: '项目标题',
    CorrectAnswer: '正确答案',
    Creating: '正在创建',
    CreatedSuccessfully: '创建成功',
    ConclusionNormalEnd: '结束语-正常结束',
    ConclusionEarlyTermination: '结束语-提前结束'
  },
  Paper: {
    Title: '问卷标题',
    Depict: '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！',
    endPageNormalMsg: '您已完成本次问卷，感谢您的帮助与支持',
    endPageAdvanceMsg: '不好意思，您不太适合本次调查，谢谢您的参与',
  },
  AdvancedScript: {
    ConditionalFunctionsAndUsage: '条件函数/使用',
    Normal: '普通',
    Normal1: '(单选、下拉、图片选择、判断、多选)',
    Normal2: '(量表、星级)',
    Normal3: '(矩阵单选)',
    Normal4: '(矩阵星级)',
    Normal5: '(矩阵填空、矩阵组合)',
    Function: '函数',
    Exist1: '多选存在选项',
    Exist2: '矩阵多选存在选项',
    Exist3: '多选不存在选项',
    Exist4: '矩阵多选不存在选项',
    Include1: '多选包含选项',
    Include2: '矩阵多选包含选项',
    IsShow: '试题显示',
    IsHide: '试题不显示',
    IsAnswered: '试题已答',
    Help: '执行函数/使用',
    Help1: '矩阵行显示',
    Help2: '矩阵行隐藏',
    Help3: '试题显示',
    Help4: '试题隐藏',
    Help5: '赋值',
    Help6: '跳转到',
    Help7: '复原跳转逻辑',
    Illustrate: '说明',
    Illustrate1: '试题编码',
    Illustrate2: '行号',
    Illustrate3: '选项序号',
    Illustrate4: '选中选项数量'
  },
  login: {
    accountLogin: '账号登录',
    quickLogin: '快捷登录',
    userRegistration: '用户注册',
    changePassword: '修改密码',
    forgotPassword: '忘记密码',
    login: '登录',
    pleaseEnterTheVerificationCode: '请输入验证码',
    obtainVerificationCode: '获取验证码',
    registerNow: '立即注册',
    returnToLogin: '返回登录',
    pleaseEnterNewPassword: '请输入新密码',
    loginWasSuccessful: '注册成功！',
    LoginSucceeded: '登录成功！',
    LogOutOfLogin: '退出登录',
  },
  titleEditor: {
    QuoteTheAnswerFromThePreviousQuestion: '引用前面题目的答案',
    introduce: '引入',
    quote: '引用',
    CiteTheAnswersToThePreviousQuestionsToTheFollowingText: '将前面题目的答案引用到下文',
    ThereAreCurrentlyNoTestQuestionsToCite: '暂无可引用的试题',
    PleaseSelectTheTestQuestion: '请选择试题',
    QuestionNumber: '题号',
    SeniorEditor: '高级编辑'
  },
  MyDownloads: {
    FileName: '文件名称',
    FileType: '文件类型',
    Time: '时间',
    FileSize: '文件大小',
    State: '状态',
    CanDownloaded: '可以下载',
    Download: '下载',
    DataPreparationProgress: '数据准备中',
    CanDownloaded: '可以下载',
    ExportException: '导出异常',
    DataExpiration: '数据过期'
  },
  ...UserAnswer,
  ...PublishProject,
  ...SetUp,
  ...Appearance,
  ...DataRecycling,
  ...Preview,
  ...QuesLibrary,
  ...Personal,
  ...Mywallet,
  ...Quota,
  ...zhLocale
};
export default lang